import { useEffect, useRef, useState } from "react";
import { useInView } from "@/lib/useReveal";

export const CountUp = ({ end = 100, duration = 1400, prefix = "", suffix = "", decimals = 0, className = "" }) => {
  const [ref, inView] = useInView({ threshold: 0.3 });
  const [value, setValue] = useState(0);
  const startTsRef = useRef(null);
  const rafRef = useRef(null);

  useEffect(() => {
    if (!inView) return undefined;
    const prefersReduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (prefersReduced) {
      setValue(end);
      return undefined;
    }
    const tick = (ts) => {
      if (!startTsRef.current) startTsRef.current = ts;
      const elapsed = ts - startTsRef.current;
      const p = Math.min(1, elapsed / duration);
      const eased = 1 - Math.pow(1 - p, 3);
      if (p >= 1) {
        setValue(end);
      } else {
        setValue(end * eased);
        rafRef.current = requestAnimationFrame(tick);
      }
    };
    rafRef.current = requestAnimationFrame(tick);
    return () => {
      if (rafRef.current) cancelAnimationFrame(rafRef.current);
    };
  }, [inView, end, duration]);

  const formatted = value.toLocaleString(undefined, {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  });

  return (
    <span ref={ref} className={className}>
      {prefix}
      {formatted}
      {suffix}
    </span>
  );
};
